import ImageMap from "image-map";
import jQuery from "jquery";

(function ($) {
    if (!$(".imageMapContainer").length) return;

    ImageMap("img[usemap]");

    const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const calculateOffsets = (pos, popupWidth, popupHeight) => {
        switch (pos) {
            case "Right":
                return { x: 50, y: -(popupHeight / 2) };
            case "Left":
                return { x: -popupWidth - 50, y: -(popupHeight / 2) };
            case "Top":
                return { x: -(popupWidth / 2), y: -popupHeight - 50 };
            case "Bottom":
                return { x: -(popupWidth / 2), y: 50 };
            default:
                return { x: 50, y: 50 };
        }
    };

    $(".map-area")
        .on("mousemove", debounce(function (e) {
            const mapID = $(this).attr("data-id");
            const $popup = $("#" + mapID);
            const pos = $popup.attr("data-position");
            const popupWidth = $popup.width();
            const popupHeight = $popup.height();

            const { x: xOffset, y: yOffset } = calculateOffsets(pos, popupWidth, popupHeight);

            $popup.css({
                left: e.pageX + xOffset,
                top: e.pageY + yOffset,
            });
        }, 10)) // Adjust debounce delay as needed
        .on("mouseenter", function () {
            $(".area-details").hide();
            const mapID = $(this).attr("data-id");
            $("#" + mapID).show();
        })
        .on("mouseleave", function () {
            const mapID = $(this).attr("data-id");
            if ($(window).outerWidth() >= 1024) {
                $("#" + mapID).hide();
            }
        });
})(jQuery);
